export function buildBrowseCardPath(cardName) {
  const normalizedCardName = String(cardName || "").trim();

  if (!normalizedCardName) {
    return null;
  }

  return `/browse/cards/${encodeURIComponent(normalizedCardName)}`;
}